import { render, staticRenderFns } from "./CourseStatisticProtocolModal.vue?vue&type=template&id=165bec9a&"
import script from "./CourseStatisticProtocolModal.vue?vue&type=script&lang=js&"
export * from "./CourseStatisticProtocolModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports